import type { BaseController } from '@infra/controllers/base.controller';
import type { RecordingToggleUsecase } from 'call-recording/recording-toggle.usecase';

export type RecordingToggleInput = {
  onRecordStart: boolean;
};

export type RecordingToggleOutput = void;

export class RecordingToggleController
  implements BaseController<RecordingToggleInput, RecordingToggleOutput>
{
  constructor(private usecase: RecordingToggleUsecase) {}

  async handle(req: RecordingToggleInput): Promise<RecordingToggleOutput> {
    await this.usecase.run(req.onRecordStart);
  }
}
